export function base64ToBase64URL(base64: string) {
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
